<mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" class="px-15" fxLayoutAlign="space-between center">
        <span class="title dialog-title">Dettagli contributi versati da F24 </span>
        <button mat-icon-button mat-dialog-close (click)="dialogRef.close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>

<mat-dialog-content class="p-24 m-0">
    <contributi-pagati-tramite-F24 [dataToSendDichiarazione]="dettagliContributiVersati.dataToSendDichiarazione" [categoriaTributo]="11">
    </contributi-pagati-tramite-F24>
</mat-dialog-content>
